import React from 'react';
import Translate from '../../../../src/components/Translate/Translate';
import CustomSelect from '../../../../src/components/Fields/CustomSelect';
import {FormFieldConfigSize} from '../../../../src/@types/components/Form';
import classnames from '../../../../src/helpers/classnames';
import trans from '../../../../src/helpers/trans';
import {Controller, useFormContext} from 'react-hook-form';
import {taskTypesOptions} from './TaskForm';
import FormErrorMessage from '../../../../src/components/Form/FormErrorMessage';
import {TaskRepresentationProps} from './representations/VoidTask';

export default function TaskTypeField({formId, task, isDisabled}: {
    formId: string,
    task: TaskRepresentationProps<any>['task'],
    isDisabled?: boolean,
}) {
    isDisabled ??= Boolean(task.id);
    const {control} = useFormContext();

    return <Controller
            name="type"
            control={control}
            render={(
                    {
                        field: {name, value, onChange, onBlur},
                        fieldState: {error}
                    }
            ) => {
                return <>
                    <Translate<HTMLLabelElement>
                            message="TaskForm.fields.type"
                            tag="label"
                            className="col-form-label-sm col-form-label"
                    />

                    <CustomSelect
                            label="TaskForm.fields.type"
                            size={FormFieldConfigSize.SM}
                            className={classnames({'is-invalid': error})}
                            isInvalid={Boolean(error)}
                            name={name}
                            value={value}
                            disabled={isDisabled}
                            options={taskTypesOptions.map(option => {
                                option.label = trans(option.label);

                                return option;
                            })}
                            onChange={onChange}
                            onBlur={onBlur}
                            formId={formId}
                            menuPortalTarget={document.body}
                    />

                    <FormErrorMessage fieldName="type"/>
                </>;
            }}
    />;
}
